import {useEffect, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";
import DatatableBase from "Components/Datatable/DatatableBase";
import {Datatable_Column} from "Components/Datatable/DatatableComponents/DatatableColumn";
import {isInObject} from "Utils/utilityFunctions";
import {setGlobalErrorStatus} from "Components/StatusHandling";
import {ERROR_MESSAGES} from "Utils/constants";
import {getNewPSOList} from "./ViewBatchAxiosFuncs";

const NewPSOTable = ({batchId}) => {
  const dispatch = useDispatch();
  const loginInfo = useSelector((s) => s.loginInfo);
  const location = useLocation();
  
  const [filter, setFilter] = useState(null);
  const [sortColumn] = useState({sortField: "listingDate", sortDirection: "desc"});
  
  useEffect(() => {
    const passed = location.state;
    if (isInObject("filter", passed)) {
      setFilter(passed.filter);
    } else {
      setFilter({
        startIndex: 0,
        entryPerPage: 10,
        sortingColumn: sortColumn.sortField,
        sortingOrder: sortColumn.sortDirection,
        searchTerm: ""
      });
    }
  }, []);
  
  const handleDateFormat = (time) => {
    if (time == null) return "";
    const d = new Date(time);
    const pad2 = (n) => String(n).padStart(2, "0");
    return `${pad2(d.getMonth() + 1)}/${pad2(d.getDate())}/${d.getFullYear()} `;
  };
  
  const getData = async (flt) => {
    try {
      return await getNewPSOList("Bearer " + loginInfo.token, flt, batchId);
    } catch (error) {
      const payload = error?.data ?? error;
      setGlobalErrorStatus({
        dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: payload?.data?.globalErrorMessageList?.[0] ?? ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {redirect: false, redirectFirst: false, path: "", data: {}},
        error
      });
      return {status: -1, data: {totalCount: 0, entryList: []}};
    }
  };
  
  const getListCols = (selected, sortingInfo) => {
    const cols = [];
    cols.push(Datatable_Column({
      name: "PSO ID",
      columnName: "psoId",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 0,
      sortingInfo
    }));
    cols.push(Datatable_Column({
      name: "PSO Name",
      columnName: "psoName",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 1,
      sortingInfo
    }));
    cols.push(Datatable_Column({
      name: "Listing Date",
      columnName: "listingDate",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 2,
      sortingInfo,
      formatFunction: (x) => handleDateFormat(x)
    }));
    cols.push(Datatable_Column({
      name: "AO Name",
      columnName: ["firstName", "lastName"],
      concatColName: "fullName",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 3,
      sortingInfo
    }));
    cols.push(Datatable_Column({
      name: "AO Email",
      columnName: "email",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 4,
      sortingInfo
    }));
    cols.push(Datatable_Column({
      name: "Status",
      columnName: "status",
      selectedRows: selected,
      sortable: true,
      sortFieldNum: 5,
      sortingInfo
    }));
    return cols;
  };
  
  return (
    <>
      {filter && (
        <DatatableBase
          tableClassName="newPsoTable"
          uniqueId="newPsoTable"
          filter={filter}
          setFilter={setFilter}
          getData={getData}
          getListCols={getListCols}
          searchFieldText={"Search by PSO ID"}
          hasSelectableRows={false}
          datatableHeader={null}
          datatableDescription={null}
          sortingColumn={sortColumn.sortField}
          sortingOrder={sortColumn.sortDirection}
        />
      )}
    </>
  );
};

export default NewPSOTable;
